import React from "react";

const NotFoundPage = () => <div>pag nao encontrada</div>;

export default NotFoundPage;
